export default "__VITE_ASSET__7fse8CFA__"